import axios from "axios";
require("dotenv").config();

const api = axios.create({
  // baseURL: "https://gcloud.kiteradar.com.br",
  baseURL: process.env.REACT_APP_API_BASE_URL,
  headers: {
    authorization: `Bearer ${process.env.REACT_APP_AUTORIZATION}`,
  },
});

export default api;
